<template>
  <!--查看-->
  <div class="order-detail-modal">
    <div class="form-container">
      <div class="top-title">
        <div class="font-18 m-b-16">订单信息</div>
        <div class="top-title-two">
          <span class="form-label">预定人：</span>
          <span class="color-333 m-r-10">{{formData.bookerName}}</span>
          <span class="blue-text">{{formData.bookerPhone}}</span>
        </div>
      </div>
      <div class="detail-box">
        <el-row :gutter="10">
          <el-col :span="12">
            <div class="flex">
              <div class="form-label w-90">订单编码：</div>
              <span class="text-ellipsis color-333" :title="formData.orderCode">{{formData.orderCode}}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <span class="form-label">订单类型：</span>
            <span class="color-333">{{formData.orderTypeName}}</span>
          </el-col>
          <el-col :span="6">
            <span class="form-label">订单来源：</span>
            <span class="color-333">{{formData.orderSourceName}}</span>
          </el-col>
        </el-row>
      </div>

      <div class="font-18 m-b-16 m-t-16">房源信息</div>
      <div class="detail-box">
        <el-row :gutter="10" class="m-b-10">
          <el-col :span="12">
            <span class="form-label">门店：</span>
            <span class="color-333">{{formData.storeName}}</span>
          </el-col>
          <el-col :span="12">
            <span class="form-label">房型：</span>
            <span class="color-333">{{formData.roomTypeName}}</span>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <span class="form-label">房源名称：</span>
            <span class="color-333">{{formData.roomName}}</span>
          </el-col>
          <el-col :span="12">
            <span class="form-label">房源编码：</span>
            <span class="color-333">{{formData.roomCode}}</span>
          </el-col>
        </el-row>
      </div>

      <div class="font-18 m-b-16 m-t-16" style="display: flex; justify-content: space-between;">
        <span>入住信息</span>
        <a @click="share" style="cursor: pointer;" v-if="formData.orderState < 4">订单分享</a>
      </div>
      <div class="detail-box">
        <el-row :gutter="10" class="m-b-10">
          <el-col :span="24">
            <span class="form-label">入离时间：</span>
            <span class="color-333 m-r-20">{{formData.startTime}} - {{formData.endTime}}</span>
            <span class="color-333">{{formData.timeStr}}</span>
          </el-col>
        </el-row>
        <!-- <div style="width:90%"> 
          <i
            class="fa icon-eye"
            :class="[hiddenNumberBol ? 'fa-eye-slash' : 'fa-eye']"
            @click="switchNumberHiddenOrShow()"
          ></i>
        </div> -->
        
        <el-row class="m-b-10" :gutter="10" v-for='(item, index) in formData.checkInPersonInfoDTOS' :key="'person_'+index">
          <el-col :span="10">
            <span class="form-label">入住人：</span>
            <template v-if="item.verificationStatus == 1">
              <el-input v-model="item.personName" style="display: inline-block; width: 160px;"/>
              <el-input v-model="item.certificateNumber"  style="display: inline-block; width: 180px;"/>
            </template>
            <span v-else>{{item.personName || '--'}} {{item.personPhone || '--'}}</span>
            <!-- <span>{{hiddenNumberBol ? '***' : item.personName}} {{item.personPhone ? (hiddenNumberBol ? '***********' : item.personPhone) : '--'}}</span> -->
            <!-- <el-image v-if="item.verificationStatus == 2" src="https://rwke.reconova.com:11080/saas/upgradePackage/wximg/2.0/cert_ok.png" /> -->
            <span v-if="item.verificationStatus == 2" style="border: 1px solid green; font-size: 8px; padding: 2px; color: green; transform: translate(0px, -8px) scale(0.8); display: inline-block;">已认证{{item.manualVerifyStatus == 1 ? '(人工)' : ''}}</span>
            <span v-else-if="item.verificationStatus == 1" style="border: 1px solid red; font-size: 8px; padding: 2px; color: red; transform: translate(0px, -8px) scale(0.8); display: inline-block;">核验失败</span>
            <span v-else-if="item.verificationStatus == 0" style="border: 1px solid orange; font-size: 8px; padding: 2px; color: orange; transform: translate(0px, -8px) scale(0.8); display: inline-block;">未核验</span>
          </el-col>
          <el-col :span="14" v-if="item.verificationStatus == 1">
            <span class="form-label">身份证照片：</span>
            <el-upload
              ref="idCardUpload"
              class="upload-demo"
              :action="uploadUrl"
              :headers="{
                Authorization,
              }"
              list-type="picture-card"
              :before-upload="beforeAvatarUpload"
              name="file"
              :on-exceed="handleExceed"
              :on-success="(response, file) => handleUploadSuccess(response, file, idCardPicIds, index)"
              :on-remove="(file) => handleUploadRemove(file, idCardPicIds, index)"
              :limit="1"
              :file-list="idCardPicIds[index]">
              <template #default>
                <el-icon><plus /></el-icon>
              </template>
              <template #file="{file}">
                <img 
                  :src="file.url" alt=""
                  style="width: 100%; height: 100%;"
                  @click="removeFile('idCardUpload', index)"
                />
              </template>
            </el-upload>
            <span class="form-label">人脸照片：</span>
            <el-upload
              ref="faceUpload"
              class="upload-demo"
              :action="uploadUrl"
              :headers="{
                Authorization,
              }"
              list-type="picture-card"
              :before-upload="beforeAvatarUpload"
              name="file"
              :on-exceed="handleExceed"
              :on-success="(response, file) => handleUploadSuccess(response, file, facePicIds, index)"
              :on-remove="(file) => handleUploadRemove(file, facePicIds, index)"
              :limit="1"
              :file-list="facePicIds[index]">
              <template #default>
                <el-icon><plus /></el-icon>
              </template>
              <template #file="{file}">
                <img 
                  :src="file.url" alt="" 
                  style="width: 100%; height: 100%;" 
                  @click="removeFile('faceUpload', index)"
                />
              </template>
            </el-upload>
            <el-button @click="verify(item.id, index)" type="primary">人工认证</el-button>
            <!-- <span class="form-label">房源编码：</span>
            <span>{{formData.roomCode}}</span> -->
            <!-- <span class="form-label">防疫资料：</span>
            <span class="cursor-p color-333" @click="handleDispatchClick(`image-${index}`)">查看</span>
            <el-image
              class="image-hide"
              :ref="`image-${index}`"
              :src="item.picUrl || item.travelCodeUrl"
              :preview-src-list="(item.picUrl && item.travelCodeUrl) ?[item.picUrl, item.travelCodeUrl]:(item.picUrl?[item.picUrl]:[item.travelCodeUrl])"
              fit="cover">
            </el-image> -->
          </el-col>
        </el-row>
      </div>

      <div class="font-18 m-b-16 m-t-16">备注</div>
      <div class="detail-box">
        <el-row :gutter="10">
          <el-col :span="24">
            <span>{{formData.remark ? formData.remark : '--'}}</span>
          </el-col>
        </el-row>
      </div>
    </div>
    
    <div class="form-footer">
      <el-row :gutter="10">
        <el-col :span="14">
          <div class="order-type m-b-10">
            <span>订单类型：</span>
            <span>{{ formData.orderType == 1 ? '全日房' : '钟点房' }}</span>
          </div>
          <div class="room-price flex">
            <span>房费：</span>
            <span class="price">￥{{ formData.orderPrice }}</span>
          </div>
        </el-col>
        <el-col :span="10" v-if="formData.orderState < 4">
          <div class="flex-bottom w-p-100 h-p-100">
            <el-button class="submit-btn" @click="handleRowEdit('edit')" :disabled="!(formData.orderState==1||formData.orderState==2||formData.orderState==3)">修改订单</el-button>
            <el-button class="cancel-btn" @click="handleRowEdit('cancel')" :disabled="!(formData.orderState==1||formData.orderState==2)">取消订单</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="dialog" v-if="isShare">
      <div class="box" id="poster">
        <div class="header">{{formData.roomName}}</div>
        <div class="close" @click="isShare = false">
          <el-icon :size="20">
            <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" data-v-ea893728=""><path fill="currentColor" d="M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z"></path></svg>
          </el-icon>
        </div>
        <div class="content">
          <div class="description">
            <div class="item">
              <div class="title">入住时间</div>
              <div class="value">{{formData.startTime}}</div>
            </div>
            <div class="item">
              <div class="title">离店时间</div>
              <div class="value">{{formData.endTime}}<span style="margin-left: 16px;">{{formData.timeStr}}</span></div>
            </div>
          </div>
          <div class="qrcode"><img :src="qrcode" alt=""></div>
          <div class="hint">微信扫码，查看入住登记</div>
          <div class="footer">
            <el-button @click="download" class="confirm">下载二维码</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import html2canvas from "html2canvas";
  import RichText from "@/components/common/RichText/RichText";
  import {
    mapActions
  } from 'vuex'
  import formCheck from '@/components/common/formCheck'
  import orderMix from './mixin.js'
  const imageConversion = require("image-conversion");
  export default {
    components: {
      RichText},
    mixins: [ formCheck, orderMix],
    name: "publishDetailModel",
      props:{
        selOptions: {
          type: Object,
          default:{rooms:[],roomType:[],platform:[],orderType:[{code:1,name:'全日房'},{code:2,name:'钟点房'}]},
        },
        selMapsWyfbm:{
          type: Object,
          default:{}
        },
        detailModal:{
          type:Boolean,
          default:''
        },
        detailData:{
          type:Object,
          default:{}
        },
        detailType:{
          type:String,
          default:'show'
        }
      },
      data(){
        return{
          Authorization: localStorage.getItem('Authorization'),
          hiddenNumberBol:true,
          isValid:true,
          activeNames: ['1','2','3','4','5','6','7'],
          showType:'',
          saveLoading:false,
          formData:{},
          uploadUrl:'',
          idCardPicIds:[],
          facePicIds: [],
          isShare: false,
          qrcode: "",
        }
    },
    created(){
      this.uploadUrl = location.origin + '/saas/api/web/fileStorage/upload'
    },
    mounted(){
      this.showType = this.detailType
    },
    watch:{
      detailType(val){
        this.showType = val
      },
      detailModal:{
        immediate: true,
        handler: function(to){
          if(to===false){
            return false
          }
          this.$nextTick(()=>{
            this.initFormData()
          })
        }
      }
    },
    methods:{
      ...mapActions([
        'alertToggle',
        'fetchData'
      ]),
      getQRCode(){
        this.fetchData({
          url:'ORDER.GET_ORDER_QRCODE', 
          method: 'get', 
          params:{
            orderCode: this.formData.orderCode
          },
          timeout:0, 
          isLoading:false,
          headers: {
            'Content-Type': "application/json",
          }
        }).then((res)=>{
          this.qrcode = "data:image/png;base64," + res;
        });
      },
      share(){
        this.isShare = true;
      },
      download(){
        const canvas = document.createElement("canvas");
        const poster = document.getElementById("poster");
        html2canvas(poster).then(canvas => {
          canvas.toBlob(blob => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "qrcode.png";
            a.click();
            window.URL.revokeObjectURL(url);
          });
        })
      },
      removeFile(refName, index){
        this.$refs[refName][index].clearFiles();
        if(refName == 'idCardUpload'){
          this.idCardPicIds[index] = [];
        }
        if(refName == 'faceUpload'){
          this.facePicIds[index] = [];
        }
      },
      verify(personId, index){
        this.$confirm("已对办理入住人进行身份和证件合适，确定信息一致。", "人工认证").then(() => {
          if(!this.idCardPicIds[index] || !this.facePicIds[index]){
            return this.$message.error("请填写完整资料");
          }
          this.fetchData({
            url:'ORDER.MANUAL_VERIFY', 
            method: 'post', 
            params:{
              cardImgId: this.idCardPicIds[index][0].dataId,
              faceId: this.facePicIds[index][0].dataId,
              manualVerifyStatus: 1,
              personId,
            },
            timeout:0, 
            isLoading:false,
            headers: {
              'Content-Type': "application/json",
            }
          }).then((res)=>{
            console.log(res);
            this.formData.checkInPersonInfoDTOS[index].verificationStatus = 2;
            this.formData.checkInPersonInfoDTOS[index].manualVerifyStatus = 1;
            this.$message.success('操作成功！')
          }).catch((err)=>{
            this.$message.error('操作失败！')
          })
        })
      },
      handleUploadRemove(file, fileList, index){
        let key = -1
        fileList[index].length && fileList[index].forEach((item,index)=>{
          if(item.name==file.name){
            key = index
          }
        })
        this.$nextTick(()=>{
          (key>=0) && fileList[index].splice(key,1)
        })
      },
      handleExceed(files, fileList) {
        this.$message.warning('最多上传1张照片');
      },
      handleUploadSuccess(response, file, fileList, index){
        if(!response || !response.data || !response.data.id){
          return false
        }
        if(fileList[index]){
          fileList[index].push({...file,dataId:response.data.id})
        }else{
          fileList[index] = [{...file,dataId:response.data.id}];
        }
      },
      beforeAvatarUpload(file) {
        let tailType = file.name.slice(file.name.lastIndexOf(".") + 1)
        let isType = ["jpeg", "jpg", "png"].indexOf(tailType.toLowerCase()) > -1
        if (!isType) {
          this.alertToggle({
            alertType: "danger",
            alertContent: "只能上传jpeg/jpg/png文件"
          })
          return false
        }

        const isLtM = file.size / 1024 / 1024 <= 4;
        if (!isLtM) {
          this.$message.error('上传附件大小不能超过 4MB!');
          return false
        }
        //return isLtM ;
        return new Promise((resolve) => {
          // 压缩到100KB,这里的100就是要压缩的大小,可自定义，imageConversion.compressAccurately(file, 100)
          //compress按比例压缩0.3
          imageConversion.compressAccurately(file, 100).then(res=>{
            resolve(res);
          })
        })
      },
      /**
       * 切换敏感信息加密状态
       */
      switchNumberHiddenOrShow() {
        this.hiddenNumberBol = !this.hiddenNumberBol;
      },
      //初始化表单数据  
      initFormData(){
        //已预订和已登记的记录拟入住和拟离开时间；已入住的则是记录实际的入住和拟离开时间；已完成的 是真实的入住时间和离开时间
        //1-已预订，2-已登记，3-已入住，4-已完成，5-已取消，6-已失效
        if(this.detailData.orderState==3){
          this.formData.startTime = this.detailData.actualCheckInTime
          this.formData.endTime = this.detailData.proposedCheckOutTime
        }else if(this.detailData.orderState==4){
          this.formData.startTime = this.detailData.actualCheckInTime
          this.formData.endTime = this.detailData.actualCheckOutTime
        }else{
          this.formData.startTime = this.detailData.proposedCheckInTime
          this.formData.endTime = this.detailData.proposedCheckOutTime
        }

        //1-超管，2-管理员，3-审核，4-经营者，5-管家，6-运维APP人员，7-租客
        let curUser = localStorage.getItem('user')
        this.formData.showStore = (curUser.userType==1 || curUser.userType==2) ? true:false

        this.formData = {...this.formData, ...this.detailData}
        this.formData.checkInPersonInfoDTOS.forEach((item, index) => {
          const {photoIds, photoUrl, cardImgId, cardImgUrl} = item;
          if(cardImgUrl && cardImgId){
            this.idCardPicIds[index] = [{
              url: cardImgUrl,
              dataId: cardImgId,
            }]
          }
          if(photoUrl && photoIds){
            this.facePicIds[index] = [{
              url: photoUrl,
              dataId: photoIds,
            }]
          }
        })
        this.$nextTick(()=>{
          this.pickTimeChange(this.formData.orderType)
          this.getQRCode();
        })
        
      },
      //获取时间间隔,1-全日房，2-钟点
      pickTimeChange(val){
        let diffs = this.getDiffTime(this.formData.startTime,this.formData.endTime,this.formData.orderType)
        if(diffs){
          this.formData.timeStr = (this.formData.orderType==1)?diffs+'晚':diffs+'小时'
        }else{
          this.formData.timeStr = '--'
        }
      },

      //操作
      handleRowEdit(opType){
        if(opType == 'edit'){
          this.$emit('handleRowEdit',this.detailData,opType)
        }else{
          this.$confirm('该操作是不可恢复的，是否取消订单!', { type: 'warning' }).then(() => {
            this.doCancelSave()
          }).catch((err) => {
            console.log(err,'========00')
          })
        }
      },
      //行取消-保存
      doCancelSave(){
        
        let url = 'SAAS.ORDER_EDIT_CANCEL'
        let params = {id:this.detailData.id}

        this.fetchData({url:url, method: 'post', params:params,timeout:0, isLoading:false, flag:true}).then((res)=>{
          if(res.code==200){
            this.$message.success(res.msg||'操作成功！')
            this.$emit('submitSuccess')
            // this.submitSuccess()
          }else{
            this.$message.error(res.msg||'操作失败！')
          }
        }).catch((err)=>{
          this.$message.error('操作失败！')
        })
      },
      // 处理点击事件触发
      handleDispatchClick(refName) {
        console.log(refName, '================ refName');
        console.log(this.$refs[refName][0], '================= this.$refs[refName]');
        // console.log(, '================= this.$refs[refName]');
        this.$refs[refName][0].showViewer = true
        // this.$refs[refName][0].dispatchEvent(new MouseEvent('click'))
      }
    },
  }
</script>

<style lang="less">
.order-detail-modal{
  .el-upload-list--picture-card .el-upload-list__item{
    width: 48px;
    height: 48px;
  }
  .el-upload--picture-card{
    width: 48px;
    height: 48px;
  }
  .el-upload--picture-card i{
    margin-top: 8px;
  }
  .upload-demo{
    display: inline-block;
    margin-right: 16px;
  }
}
</style>

<style lang="less" scoped>
.dialog{
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  .box{
    width: 300px;
    height: 365px;
    background-color: white;
    border-radius: 8px;
    padding: 16px;
    position: relative;
    .header{
      text-align: center;
      font-size: 18px;
      color: #222229;
      margin-bottom: 16px;
    }
    .close{
      position: absolute;
      right: 8px;
      top: 8px;
    }
    .content{
      .description{
        .item{
          display: flex;
          .title{
            font-size: 14px;
            color: #888889;
            margin-right: 8px;
          }
          .value{
            font-size: 14px;
            color: #222229;
          }
        }
      }
      .qrcode{
        display: flex;
        justify-content: center;
        margin: 16px 0;
        img{
          width: 140px;
          height: 140px;
          border-radius: 4px;
        }
      }
      .hint{
        text-align: center;
        font-size: 14px;
        color: #888889;
      }
      .footer{
        display: flex;
        justify-content: center;
        margin: 16px 0;
        .confirm{
          width: 242px;
          height: 40px;
          border-radius: 4px;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 8px 20px;
          background: #0FAB6B;
          color: white;
        }
      }
    }
  }
}
.order-detail-modal {
  position: relative;
  margin: 0px -60px;
  overflow-x: hidden;
}
.form-container {
  padding: 0px 60px;
  max-height: 600px;
  overflow-y: auto;
}
.form-footer {
  padding: 0px 60px;
  padding-top: 20px;
  .order-type {
    font-size: 16px;
  }
  .room-price {
    align-items: center;
    font-size: 18px;
    .price {
      font-size: 22px;
      font-weight: bold;
      color: #ff4c4c;
    }
  }
  .flex-bottom {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
  }
  .h-p-100 {
    height: 100%;
  }
}
.top-title {
  display: flex;
  width: 100%;
  .top-title-two {
    flex-grow:1;
    text-align: right;
    padding-right: 15px;
  }
}
.detail-box {
  width: 100%;
  background-color: #f5f5f5;
  padding: 18px 30px;
  border-radius: 3px;
}
.image-hide {
  max-width: 0px;
  max-height: 0px;
}

.blue-text{
  color: rgb(56, 147, 215);
  line-height: 32px;
}
.text-ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.form-label {
  color: #8c8c8c;
}
.color-333 {
  color: #333;
}
.flex {
  display: flex;
}
.cursor-p {
  cursor: pointer;
}
</style>

